import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlockedVideoMassageComponent } from './blocked-video-massage/blocked-video-massage.component';

const routes: Routes = [
//   {
//     path:'l',
//     component:BlockedVideoMassageComponent
//   }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedRoutingModule { }